import React, { useEffect, useState } from 'react';
import { useContracts } from '../../hooks/useContract';
import { useNotify } from '../../context/NotificationContext';
import { ButtonSpinner, InlineLoader } from '../common/Loader';
import { parseError } from '../../utils/errors';
import { bnToNumber } from '../../utils/format';
import { NUM_MILESTONES } from '../../utils/constants';

export const MilestoneRewarder = () => {
  const { viewsR, adminW } = useContracts();
  const notify = useNotify();

  const [selected, setSelected] = useState(0);
  const [eligible, setEligible] = useState(null);
  const [total, setTotal] = useState(0);
  const [busyId, setBusyId] = useState(null);
  const [manualId, setManualId] = useState('');
  const [reload, setReload] = useState(0);

  const PAGE_SIZE = 25;

  useEffect(() => {
    let cancelled = false;
    const load = async () => {
      if (!viewsR) return;
      try {
        const res = await viewsR.getEligibleUsersForMilestone(selected, 0, PAGE_SIZE);
        if (cancelled) return;
        setEligible(res.ids);
        setTotal(bnToNumber(res.totalScanned));
      } catch (e) {}
    };
    load();
    return () => { cancelled = true; };
  }, [viewsR, selected, reload]);

  const mark = async (uid) => {
    if (!adminW) return;
    setBusyId(String(uid));
    try {
      const tx = await adminW.markMilestoneRewarded(uid, selected);
      notify.info('Marking...');
      await tx.wait();
      notify.success(`User #${uid} marked as rewarded`);
      setReload((r) => r + 1);
    } catch (e) {
      notify.error(parseError(e));
    } finally {
      setBusyId(null);
    }
  };

  const markManual = async () => {
    if (!manualId) return;
    await mark(manualId);
    setManualId('');
  };

  return (
    <div>
      <div className="card mb-24">
        <div className="section-title">Milestone Selection</div>
        <div className="input-group">
          <label className="input-label">Milestone #</label>
          <select className="select" value={selected} onChange={(e) => setSelected(Number(e.target.value))}>
            {Array.from({ length: NUM_MILESTONES }).map((_, i) => (
              <option key={i} value={i}>Milestone {i + 1}</option>
            ))}
          </select>
        </div>
        <div className="input-group">
          <label className="input-label">Manual User ID</label>
          <input className="input" type="number" value={manualId} onChange={(e) => setManualId(e.target.value)} />
        </div>
        <button className="btn btn-primary" disabled={!manualId || busyId === manualId} onClick={markManual}>
          {busyId === manualId && <ButtonSpinner />}Mark as Rewarded
        </button>
      </div>

      <div className="card">
        <div className="section-title">Eligible & Unrewarded Users</div>
        <p style={{ fontSize: 13, color: 'var(--text-secondary)', marginBottom: 12 }}>
          Scanned {total} users · Showing first {PAGE_SIZE} matches
        </p>
        {!eligible ? <InlineLoader /> : eligible.length === 0 ? (
          <div style={{ padding: 20, color: 'var(--text-tertiary)', textAlign: 'center' }}>
            No eligible users pending reward.
          </div>
        ) : (
          <div className="table-wrap">
            <table className="table">
              <thead><tr><th>User ID</th><th style={{ textAlign: 'right' }}>Action</th></tr></thead>
              <tbody>
                {eligible.map((uid) => (
                  <tr key={uid.toString()}>
                    <td>#{uid.toString()}</td>
                    <td style={{ textAlign: 'right' }}>
                      <button className="btn btn-secondary btn-sm" onClick={() => mark(uid.toString())} disabled={busyId === uid.toString()}>
                        {busyId === uid.toString() && <ButtonSpinner />}Mark
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
};
